export default __webpack_public_path__ + "static/media/albert_icon.0b1d7da9.svg";